import {css} from 'lit';
export const styles = css`:host {
  --status-border-size: 2px;
  --button-size: 32px;
  --slot-font-size: 24px;
  --icon-size: 16px;
  --right: 0.25;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}

:host([layout='lg']) {
  --avatar-border-size: 6px;
  --avatar-size: 120px;
  --avatar-font-size: var(--font-size-xl);
  --avatar-label-font-size: var(--font-size-lg);
  --status-size: 20px;
}

:host([layout='md']) {
  --avatar-border-size: 4px;
  --avatar-size: 80px;
  --avatar-font-size: var(--font-size-md);
  --avatar-label-font-size: var(--font-size-sm);
  --status-size: 16px;
  --button-size: 28px;
  --icon-size: 10px;
}

:host([layout='sm']) {
  /* stylelint-disable-next-line length-zero-no-unit */
  --avatar-border-size: 0px;
  --avatar-size: 60px;
  --avatar-font-size: var(--font-size-sm);
  --avatar-label-font-size: var(--font-size-xs);
  --status-size: 16px;
  --slot-font-size: var(--font-size-base);
  --button-size: 24px;
  --icon-size: 8px;
  --right: 0.35;
}

:host([layout='xs']) {
  /* stylelint-disable-next-line length-zero-no-unit */
  --avatar-border-size: 0px;
  --avatar-size: 40px;
  --avatar-font-size: var(--font-size-sm);
  --avatar-label-font-size: var(--font-size-xs);
  --status-size: 14px;
  --slot-font-size: var(--font-size-sm);
  --button-size: 18px;
  --icon-size: 6px;
  --right: 0.35;
}

:host([layout='xxs']) {
  /* stylelint-disable-next-line length-zero-no-unit */
  --avatar-border-size: 0px;
  --avatar-size: 30px;
  --avatar-font-size: var(--font-size-xs);
  --avatar-label-font-size: var(--font-size-xs);
  --status-size: 12px;
  --slot-font-size: var(--font-size-xs);
  --button-size: 16px;
  --icon-size: 4px;
  --right: 0.35;
}

ef-avatar {
  --label-font-size: var(--avatar-label-font-size);

  border: var(--avatar-border-size) solid var(--contrast-light);
}

ef-avatar.with-name {
  margin-bottom: 4px;
}

button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--button-size);
  width: var(--button-size);
  margin-bottom: 6px;
  border: 2px solid var(--contrast-light);
  border-radius: 50%;
  background-color: var(--primary-500);
  color: var(--contrast-light);
  z-index: 1;
  cursor: pointer;
}

ef-icon {
  font-size: var(--icon-size);
}

button.focus-visible {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: 4px;
}

button:focus-visible {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: 4px;
}

@media (hover: hover) {
  button:hover {
    color: var(--contrast-light);
    background-color: var(--primary-600);
  }
}

button:active {
  background-color: var(--primary-700);
}

ef-online-status {
  --border: transparent;
  --border-secondary: var(--contrast-light);
  --background: transparent;
  --size: var(--status-size);
  --border-size: var(--status-border-size);

  position: absolute;
  top: calc(var(--avatar-size) - var(--size));
  right: calc(50% - var(--avatar-size) * var(--right));
  transform: translateX(50%);
}

slot::slotted(*) {
  font-weight: 700;
  font-size: var(--slot-font-size);
}

:host([label]) ef-avatar {
  margin-bottom: 16px;
}

:host .hidden ef-avatar {
  margin-bottom: 0;
}

:host([editable]) ef-avatar {
  margin-bottom: calc(
    (var(--button-size) / 2 * -1) - var(--avatar-border-size)
  );
}
`;
export default styles;
